import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { PATH_DASHBOARD } from "src/routes/paths";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import LoadingScreen from "src/components/LoadingScreen";
import {
  getCacheSessDataApi,
  getMetaListApi,
  getPayMethodDataApi,
} from "src/Api/Services/SystemConfiguration";
import PaymentMethodTable from "./PaymentMethodTable";
import useSettings from "src/hooks/useSettings";
import { Container } from "@mui/material";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
import AddPaymentMethod from "./AddPaymentMethod";

const PaymentMethod = () => {
  const { themeStretch } = useSettings();
  const [paymentData, setSaymentData] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState("");
  const [loading, setloading] = useState(true);
  const [metaData, setMetaData] = useState([]);
  const fetchData = async () => {
    try {
      const { data } = await getPayMethodDataApi();
      let newRes = data.data.length > 0 ? data.data : [];
      setSaymentData(newRes || []);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchData();
    (async () => {
      try {
        const { data } = await getMetaListApi();
        setMetaData(data?.data);
      } catch (error) {
      } finally {
        setloading(false);
      }
    })();
  }, []);
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
      <HeaderBreadcrumbs
        heading="Payment Method"
        links={[
          { name: "Dashboard", href: PATH_DASHBOARD.root },
          {
            name: "Add Payment Method",
            href: PATH_DASHBOARD.systemConfig.paymentMethod,
          },
        ]}
      />
      <div className="text-right">
        <Button
          onClick={() => {
            setShow(true);
            setEditData("");
          }}
          variant="outlined"
        >
          Add <AddIcon />
        </Button>
        <PaymentMethodTable
          data={paymentData}
          fetchData={fetchData}
          editClick={(item) => setEditData(item)}
        />
      </div>
      <CustomModalComp
        show={(editData ? true : false) || show}
        onHide={() => {
          setShow(false);
          setEditData("");
        }}
        title={`${editData ? "Edit" : "Add"} Payment Method`}
        backdrop={true}
      >
        <AddPaymentMethod
          metaData={metaData}
          fetchData={() => {
            fetchData();
            setShow(false);
            setEditData("");
          }}
          editData={editData}
        />
      </CustomModalComp>
    </Container>
  );
};

export default PaymentMethod;
